'use client'

import { useState, useRef, useEffect } from 'react'

import cn from 'clsx'

import { Button, ImageBox, Modal } from 'shared-components'

import { type LargeVideo as LargeVideoType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './LargeVideo.module.sass'
import { getVideoUrl, R2Asset } from 'shared-functions/utils'

type ExtendedLargeVideoType = LargeVideoType & {
    video: any
    videoFile: R2Asset
}

function LargeVideo({ title, videoPoster, video, videoFile }: ExtendedLargeVideoType) {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const videoUrl = getVideoUrl(videoFile, video)

    const videoRef = useRef<HTMLVideoElement>(null)

    useEffect(() => {
        if (isModalOpen && videoRef.current) {
            videoRef.current.play()
        } else {
            if (videoRef.current) {
                videoRef.current.currentTime = 0
            }
            videoRef.current?.pause()
        }
    }, [isModalOpen])

    return (
        <section className={s.LargeVideo}>
            <div className={cn(s.Cont, 'container')} onClick={() => setIsModalOpen(true)}>
                {title && <h4 dangerouslySetInnerHTML={{ __html: title }} />}
                <div className={s.Image}>
                    {videoPoster && <ImageBox image={videoPoster} alt={title || ''} width={500} height={500} />}
                    <Button title="Play Video" />
                </div>
                <div className={s.Main}>
                    {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                    <Button title="Play Video" />
                </div>
            </div>
            {isModalOpen && (
                <Modal close={() => setIsModalOpen(false)}>
                    <div className={s.Modal}>
                        {videoUrl && <video controls src={videoUrl} ref={videoRef} />}
                    </div>
                </Modal>
            )}
        </section>
    )
}

export default LargeVideo
